let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('4ZtNJ') + "ts.worker.6b584f83.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);